import { render, staticRenderFns } from "./BuyCourse.vue?vue&type=template&id=2996ab09"
import script from "./BuyCourse.vue?vue&type=script&lang=js"
export * from "./BuyCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports